import { createRouter, createWebHashHistory } from 'vue-router'


import InitialPersonalDataForm from '../views/pre-registration/InitialPersonalDataForm.vue'
import Password from '../views/pre-registration/Password.vue'
import WarningScreen from '../views/pre-registration/WarningScreen.vue'
import TypeVehicle from '../views/pre-registration/TypeVehicle.vue'
import Hub from "@/cadastro/views/pre-registration/Hub.vue";
import SelectOperation from '@/cadastro/views/pre-registration/SelectOperation.vue';

import BankDataForm from '../views/bank-data/BankDataForm.vue'

import PersonalDataForm from '../views/personal-data/PersonalDataForm.vue'
import AddressForm from '../views/personal-data/AddressForm.vue'
import UploadProof from '../views/personal-data/UploadProof.vue'
import PreviewPersonalDataFiles from '../views/personal-data/PreviewPersonalDataFiles.vue'
import SavedPersonalDataFiles from '../views/personal-data/SavedPersonalDataFiles.vue'

import VehicleFirstForm from '../views/vehicle-data/VehicleFirstForm.vue'
import VehicleSecondForm from '../views/vehicle-data/VehicleSecondForm.vue'
import VehicleFront from '../views/vehicle-data/VehicleFront.vue'
import VehicleBack from '../views/vehicle-data/VehicleBack.vue'
import VehicleTrunk from '../views/vehicle-data/VehicleTrunk.vue'
import VehicleSide from '../views/vehicle-data/VehicleSide.vue'
import PreviewVehicleFiles from '../views/vehicle-data/PreviewVehicleFiles.vue'
import SavedVehicleFiles from '../views/vehicle-data/SavedVehicleFiles.vue'

import DocumentationsFirstForm from '../views/documentations/DocumentationsFirstForm.vue'
import DocumentationsSecondForm from '../views/documentations/DocumentationsSecondForm.vue'
import UploadCnh from '../views/documentations/UploadCnh.vue'
import UploadSelfieCnh from '../views/documentations/UploadSelfieCnh.vue'
import UploadRenavam from '../views/documentations/UploadRenavam.vue'
import UploadCrlv from '../views/documentations/UploadCrlv.vue'
import PreviewDocumentationFiles from '../views/documentations/PreviewDocumentationFiles.vue'
import SavedDocumentationsFiles from '../views/documentations/SavedDocumentationsFiles.vue'

import Statements from '../views/final/Statements.vue'
import TermosDeUso from '../views/final/TermosDeUso.vue'
import ApprovalFeedbackScreen from '../views/final/ApprovalFeedbackScreen.vue'

import RegistrationStatus from '../views/RegistrationStatus.vue'

const routes = [
  //pré-cadastro
  { path: '/', name: 'InitialPersonalDataForm', component: InitialPersonalDataForm },
  { path: '/pre-cadastro/senha', name: 'Password', component: Password },
  { path: '/pre-cadastro/aviso', name: 'WarningScreen', component: WarningScreen },
  { path: '/pre-cadastro/veiculo', name: 'TypeVehicle', component: TypeVehicle },
  { path: '/pre-cadastro/operacao', name: 'SelectOperation', component: SelectOperation},
  { path: '/pre-cadastro/hub', name:'Hub', component: Hub},
  //dados bancários
  { path: '/dados-bancarios/formulario-dados-bancarios', name: 'BankDataForm', component: BankDataForm},

  //informações pessoais
  { path: '/dados-pessoais/formulario-dados-pessoais', name: 'PersonalDataForm', component: PersonalDataForm },
  { path: '/dados-pessoais/endereco', name: 'AddressForm', component: AddressForm },
  { path: '/dados-pessoais/comprovante-de-residencia', name: 'UploadProof', component: UploadProof },
  { path: '/dados-pessoais/preview-comprovante-de-residencia', name: 'PreviewPersonalDataFiles', component: PreviewPersonalDataFiles },
  { path: '/dados-pessoais/arquivos-pessoais', name: 'SavedPersonalDataFiles', component: SavedPersonalDataFiles },

  //informações do veículo
  { path: '/dados-do-veiculo/formulario-dados-veiculo-1', name: 'VehicleFirstForm', component: VehicleFirstForm },
  { path: '/dados-do-veiculo/formulario-dados-veiculo-2', name: 'VehicleSecondForm', component: VehicleSecondForm },
  { path: '/dados-do-veiculo/frente-do-veiculo', name: 'VehicleFront', component: VehicleFront },
  { path: '/dados-do-veiculo/traseira-do-veiculo', name: 'VehicleBack', component: VehicleBack },
  { path: '/dados-do-veiculo/bau-do-veiculo', name: 'VehicleTrunk', component: VehicleTrunk },
  { path: '/dados-do-veiculo/lateral-do-veiculo', name: 'VehicleSide', component: VehicleSide },
  { path: '/dados-do-veiculo/preview-imagem-veiculo', name: 'PreviewVehicleFiles', component: PreviewVehicleFiles },
  { path: '/dados-do-veiculo/arquivos-do-veiculo', name: 'SavedVehicleFiles', component: SavedVehicleFiles },

  //documentações
  { path: '/documentacoes/formulario-documentacoes-1', name: 'DocumentationsFirstForm', component: DocumentationsFirstForm },
  { path: '/documentacoes/formulario-documentacoes-2', name: 'DocumentationsSecondForm', component: DocumentationsSecondForm },
  { path: '/documentacoes/cnh', name: 'UploadCnh', component: UploadCnh },
  { path: '/documentacoes/selfie-cnh', name: 'UploadSelfieCnh', component: UploadSelfieCnh },
  { path: '/documentacoes/renavam', name: 'UploadRenavam', component: UploadRenavam },
  { path: '/documentacoes/crlv', name: 'UploadCrlv', component: UploadCrlv },
  { path: '/documentacoes/preview-imagem-documentacoes', name: 'PreviewDocumentationFiles', component: PreviewDocumentationFiles },
  { path: '/documentacoes/arquivos-de-documentacoes', name: 'SavedDocumentationsFiles', component: SavedDocumentationsFiles },

  //final
  { path: '/final/declaracoes', name: 'Statements', component: Statements },
  { path: '/final/termos-de-uso', name: 'TermosDeUso', component: TermosDeUso },
  { path: '/final/aviso', name: 'ApprovalFeedbackScreen', component: ApprovalFeedbackScreen },

  //card de status
  { path: '/status-cadastro', name: 'StatusRegistration', component: RegistrationStatus },

]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router;
